/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated by mj codegen manifest
 * App: mj_explorer
 * Dependency tree: 779 packages walked, 2 contain @RegisterClass
 *
 * This file imports every @RegisterClass decorated class by name and places
 * them in an exported array, creating a static code path that prevents
 * tree-shaking from removing them.
 */

/* eslint-disable @typescript-eslint/no-unused-vars */

// mj_generatedentities (89 classes)
import {
    CommonAguPersonEntity,
    CoreSignalAwardEntity,
    CoreSignalCertificationEntity,
    CoreSignalCourseEntity,
    CoreSignalEducation__CoreSignalEntity,
    CoreSignalExperienceEntity,
    CoreSignalLanguageEntity,
    CoreSignalMemberOrganizationEntity,
    CoreSignalPatentEntity,
    CoreSignalProfileEntity,
    CoreSignalProfileMatchEntity,
    CoreSignalProjectEntity,
    CoreSignalPublicationEntity,
    CoreSignalSkillEntity,
    FeedbackPlatformApplicationUserEntity,
    FeedbackPlatformCommitteeMemberEntity,
    FeedbackPlatformCommitteeSelectionEntity,
    FeedbackPlatformCommitteeSelectionItemEntity,
    FeedbackPlatformConversationMessageEntity,
    FeedbackPlatformConversation__FeedbackPlatformEntity,
    FeedbackPlatformNominationEntity,
    FeedbackPlatformNominationResponseEntity,
    FeedbackPlatformNotificationEntity,
    FeedbackPlatformNotificationTypeEntity,
    FeedbackPlatformParticipantEntity,
    FeedbackPlatformPresentationCategoryEntity,
    FeedbackPlatformPresentationEntity,
    FeedbackPlatformReviewAssignmentEntity,
    FeedbackPlatformReviewEntity,
    FeedbackPlatformReviewQuestionEntity,
    FeedbackPlatformReviewQuestionRubricEntity,
    FeedbackPlatformReviewQuestionTypeEntity,
    FeedbackPlatformReviewResponseEntity,
    FeedbackPlatformReviewThankYouNoteEntity,
    FeedbackPlatformSeasonEntity,
    FeedbackPlatformSectionEntity,
    FeedbackPlatformSessionEntity,
    FeedbackPlatformSessionNominatorEntity,
    FeedbackPlatformSystemSettingEntity,
    FeedbackPlatformUserNotificationSettingEntity,
    JobsIngestBatchEntity,
    JobsJobPostingEntity,
    JobsJobPostingSourceEntity,
    MAPSConferenceRegistrationEntity,
    MAPSContactMessageEntity,
    MAPSContactMessageEventEntity,
    MAPSExportLogEntity,
    MAPSPartnerTokenEntity,
    MAPSPartnerTokenUserEntity,
    MAPSPersonEntity,
    MAPSPersonHonorReceivedEntity,
    MAPSPersonJobEntity,
    MAPSPersonQualificationFactsEntity,
    MAPSPersonVolunteerActivityEntity,
    MAPSSearchLogEntity,
    MAPSUploadedDocumentEntity,
    ORCIDAddressEntity,
    ORCIDDistinctionEntity,
    ORCIDEducationEntity,
    ORCIDEmailEntity,
    ORCIDEmploymentEntity,
    ORCIDExternalIdentifierEntity,
    ORCIDFundingEntity,
    ORCIDFundingExternalIDEntity,
    ORCIDInvitedPositionEntity,
    ORCIDKeywordEntity,
    ORCIDMembershipEntity,
    ORCIDOtherNameEntity,
    ORCIDPeerReviewEntity,
    ORCIDQualificationEntity,
    ORCIDRecordEntity,
    ORCIDRecordLinkEntity,
    ORCIDResearchResourceEntity,
    ORCIDResearcherUrlEntity,
    ORCIDServiceEntity,
    ORCIDWorkEntity,
    ORCIDWorkExternalIDEntity,
    RecommendationContentEntity,
    RecommendationContributorContentEntity,
    RecommendationContributorEntity,
    ResearchCvParseEntity,
    ResearchCvTagEntity,
    ResearchMemberDocumentEntity,
    ResearchMemberItemStateEntity,
    ResearchMemberProfileEntity,
    ResearchMemberRecommendationEntity,
    adminIngestionRunEntity,
    adminIngestionTypeEntity,
    dboflyway_schema_historyEntity,
} from 'mj_generatedentities';

// agu_oep_core (11 classes)
import {
    OEPCommitteeSelectionEntity,
    OEPCommitteeSelectionItemEntity,
    OEPConversationEntity,
    OEPConversationMessageEntity,
    OEPNominationEntity,
    OEPNominationResponseEntity,
    OEPParticipantEntity,
    OEPPresentationEntity,
    OEPReviewEntity,
    OEPReviewResponseEntity,
    OEPReviewThankYouNoteEntity,
} from 'agu_oep_core';

/**
 * Runtime references to every @RegisterClass decorated class.
 * This array creates a static code path the bundler cannot tree-shake.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CLASS_REGISTRATIONS: any[] = [
    CommonAguPersonEntity,
    CoreSignalAwardEntity,
    CoreSignalCertificationEntity,
    CoreSignalCourseEntity,
    CoreSignalEducation__CoreSignalEntity,
    CoreSignalExperienceEntity,
    CoreSignalLanguageEntity,
    CoreSignalMemberOrganizationEntity,
    CoreSignalPatentEntity,
    CoreSignalProfileEntity,
    CoreSignalProfileMatchEntity,
    CoreSignalProjectEntity,
    CoreSignalPublicationEntity,
    CoreSignalSkillEntity,
    FeedbackPlatformApplicationUserEntity,
    FeedbackPlatformCommitteeMemberEntity,
    FeedbackPlatformCommitteeSelectionEntity,
    FeedbackPlatformCommitteeSelectionItemEntity,
    FeedbackPlatformConversationMessageEntity,
    FeedbackPlatformConversation__FeedbackPlatformEntity,
    FeedbackPlatformNominationEntity,
    FeedbackPlatformNominationResponseEntity,
    FeedbackPlatformNotificationEntity,
    FeedbackPlatformNotificationTypeEntity,
    FeedbackPlatformParticipantEntity,
    FeedbackPlatformPresentationCategoryEntity,
    FeedbackPlatformPresentationEntity,
    FeedbackPlatformReviewAssignmentEntity,
    FeedbackPlatformReviewEntity,
    FeedbackPlatformReviewQuestionEntity,
    FeedbackPlatformReviewQuestionRubricEntity,
    FeedbackPlatformReviewQuestionTypeEntity,
    FeedbackPlatformReviewResponseEntity,
    FeedbackPlatformReviewThankYouNoteEntity,
    FeedbackPlatformSeasonEntity,
    FeedbackPlatformSectionEntity,
    FeedbackPlatformSessionEntity,
    FeedbackPlatformSessionNominatorEntity,
    FeedbackPlatformSystemSettingEntity,
    FeedbackPlatformUserNotificationSettingEntity,
    JobsIngestBatchEntity,
    JobsJobPostingEntity,
    JobsJobPostingSourceEntity,
    MAPSConferenceRegistrationEntity,
    MAPSContactMessageEntity,
    MAPSContactMessageEventEntity,
    MAPSExportLogEntity,
    MAPSPartnerTokenEntity,
    MAPSPartnerTokenUserEntity,
    MAPSPersonEntity,
    MAPSPersonHonorReceivedEntity,
    MAPSPersonJobEntity,
    MAPSPersonQualificationFactsEntity,
    MAPSPersonVolunteerActivityEntity,
    MAPSSearchLogEntity,
    MAPSUploadedDocumentEntity,
    ORCIDAddressEntity,
    ORCIDDistinctionEntity,
    ORCIDEducationEntity,
    ORCIDEmailEntity,
    ORCIDEmploymentEntity,
    ORCIDExternalIdentifierEntity,
    ORCIDFundingEntity,
    ORCIDFundingExternalIDEntity,
    ORCIDInvitedPositionEntity,
    ORCIDKeywordEntity,
    ORCIDMembershipEntity,
    ORCIDOtherNameEntity,
    ORCIDPeerReviewEntity,
    ORCIDQualificationEntity,
    ORCIDRecordEntity,
    ORCIDRecordLinkEntity,
    ORCIDResearchResourceEntity,
    ORCIDResearcherUrlEntity,
    ORCIDServiceEntity,
    ORCIDWorkEntity,
    ORCIDWorkExternalIDEntity,
    RecommendationContentEntity,
    RecommendationContributorContentEntity,
    RecommendationContributorEntity,
    ResearchCvParseEntity,
    ResearchCvTagEntity,
    ResearchMemberDocumentEntity,
    ResearchMemberItemStateEntity,
    ResearchMemberProfileEntity,
    ResearchMemberRecommendationEntity,
    adminIngestionRunEntity,
    adminIngestionTypeEntity,
    dboflyway_schema_historyEntity,
    OEPCommitteeSelectionEntity,
    OEPCommitteeSelectionItemEntity,
    OEPConversationEntity,
    OEPConversationMessageEntity,
    OEPNominationEntity,
    OEPNominationResponseEntity,
    OEPParticipantEntity,
    OEPPresentationEntity,
    OEPReviewEntity,
    OEPReviewResponseEntity,
    OEPReviewThankYouNoteEntity,
];

/** Marker constant indicating the manifest has been loaded. */
export const CLASS_REGISTRATIONS_MANIFEST_LOADED = true;

/** Total @RegisterClass decorated classes discovered in dependency tree */
export const CLASS_REGISTRATIONS_COUNT = 100;

/** Packages imported by this manifest */
export const CLASS_REGISTRATIONS_PACKAGES = [
    'mj_generatedentities',
    'agu_oep_core',
] as const;
